import { useFlags } from "@/hooks/useFeatureFlags";

export function useQuickActionMenusRedesign() {
  const flags = useFlags();
  return !!flags["m360-quick-action-menus-redesign"];
}
